import { Icon } from '@buggy/shared'
import { Button } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import PermissionInsufficientTooltip from '@/components/common/permission-insufficient-tooltip'
import { useDirectoryActionPermission } from '@/hooks/use-permission'
import { I18nId } from '@/i18n/config'
import { useIntl } from '@/i18n/hooks/use-intl'

interface HeaderProps {
  onClickAddButton?: () => void
  titleI18nId: I18nId
}
const Header: FunctionComponent<HeaderProps> = ({
  onClickAddButton,
  titleI18nId,
}) => {
  const { formatMessage } = useIntl()
  const directoryActionPermission = useDirectoryActionPermission()

  return (
    <Wrapper>
      <div>
        {formatMessage({
          id: titleI18nId,
        })}
      </div>
      {onClickAddButton && (
        <PermissionInsufficientTooltip
          insufficient={!directoryActionPermission}
        >
          <AddButton
            disabled={!directoryActionPermission}
            icon={<Icon name='plus' />}
            onClick={onClickAddButton}
          >
            {formatMessage({ id: 'autoreport:chart_field_add_btn' })}
          </AddButton>
        </PermissionInsufficientTooltip>
      )}
    </Wrapper>
  )
}

export default Header

const AddButton = styled(Button)`
  align-self: flex-end;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  color: ${({ theme }): string => theme.colors.text.secondary};
  font-size: 16px;
  font-weight: 700;
`
